<div class="right-drawer">
  <itfg-event-log></itfg-event-log>
</div>
